import { createSlice } from '@reduxjs/toolkit';

const portalHomeSlice = createSlice({
  name: 'home',
  initialState: { screen: 'ML', isSuccess: false },
  reducers: {
    setHomeScreen: state => {
      state.isSuccess = false;
    },
    setHomeScreenSuccess: (state, { payload }) => {
      state.screen = payload.compConfig.defaultScreenCode;
      state.isSuccess = true;
    },
    setHomeScreenFail: state => {
      state.isSuccess = false;
    },
    updateHomeScreen: (state, { payload }) => {
      state.screen = payload.item;
    },
  },
});

export const { setHomeScreen, setHomeScreenSuccess, setHomeScreenFail, updateHomeScreen } = portalHomeSlice.actions;
export default portalHomeSlice.reducer;
